import React from 'react';

const ContactPage = () => {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow">
            <div className="card-body">
              <h2 className="card-title mb-4">Contact Us</h2>
              
              <p className="mb-4">
                Have questions, feedback, or suggestions about Test-Forecast? We'd love to hear from you!
              </p>
              
              <div className="mb-4">
                <h5>Contact Form</h5>
                <p>
                  Please use our Google Form to send us a message:
                </p>
                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdfWQILL4HOOweVIifwMhygltbfS4IFnWOR9ilr0gJRboiCzw/viewform?usp=header" 
                  className="btn btn-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open Contact Form
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;